



























































































import ConnectWalletNetworkBadge from '@/components/walletConnection/ConnectWalletNetworkBadge.vue'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {Vue, Component, Prop} from 'vue-property-decorator'
import QrcodeVue from 'qrcode.vue'
import {NetworkNamespace} from '@/enums/NetworkNamespace'
import {$} from '@/facade'
import {siteNetwork} from '@/helpers/NetworkModeRegistry'

@Component({
  components: {QrcodeVue, ConnectWalletNetworkBadge},
  computed: {
    NetworkNamespace() {
      return NetworkNamespace
    },
  },
})
export default class ConnectWalletWC extends Vue {
  @Prop({type: String, required: true})
  networkNamespace!: NetworkNamespace
  @Prop({type: String, default: undefined}) targetNetwork?: TWalletNetwork

  get uri(): string | null {
    const walletImplementation =
      this.networkNamespace === NetworkNamespace.x ? 'neoX' : 'n3'
    const network = this.targetNetwork ?? siteNetwork()

    return (
      this.$store.state.walletAdapter.sessions[walletImplementation][network]
        ?.uri ?? null
    )
  }

  copy() {
    if (!this.uri) {
      $.toast.error('system.info.copyError')
      return
    }

    $.utils.copyToClipboard(this.uri)
    $.toast.info('system.info.copiedToClipboard')
  }

  returnToChooseWallet() {
    this.$emit('return-page')
  }
}
